import { Action } from 'redux';

export { isLoading, doneLoading } from 'store/config/actions';

// --- Action Types ---

// Get all
export const GET_VEHICLE_PROPERTIES = 'optional-properties/GET_VEHICLE_PROPERTIES';
export interface GetVehiclePropertiesAction extends Action<typeof GET_VEHICLE_PROPERTIES> {
  readonly type: typeof GET_VEHICLE_PROPERTIES;
}

// Update vehicle properties
export const PERSIST_VEHICLE_PROPERTIES = 'optional-properties/PERSIST_VEHICLE_PROPERTIES';
export interface PersistVehiclePropertiesAction extends Action<typeof PERSIST_VEHICLE_PROPERTIES> {
  readonly type: typeof PERSIST_VEHICLE_PROPERTIES;
  readonly payload: OptionalProperties;
}

export const SAVE_VEHICLE_PROPERTIES = 'optional-properties/SAVE_VEHICLE_PROPERTIES';
export interface SaveVehiclePropertiesAction extends Action<typeof SAVE_VEHICLE_PROPERTIES> {
  readonly type: typeof SAVE_VEHICLE_PROPERTIES;
  readonly payload: OptionalProperties;
}

export type VehiclePropertiesAction =
  GetVehiclePropertiesAction | PersistVehiclePropertiesAction | SaveVehiclePropertiesAction;

// --- Actions ---

export const getVehicleProperties = (): GetVehiclePropertiesAction => ({
  type: GET_VEHICLE_PROPERTIES,
});

export const persistVehicleProperties = (properties: OptionalProperties): PersistVehiclePropertiesAction => ({
  type: PERSIST_VEHICLE_PROPERTIES,
  payload: properties,
});

export const saveVehicleProperties = (properties: OptionalProperties): SaveVehiclePropertiesAction => ({
  type: SAVE_VEHICLE_PROPERTIES,
  payload: properties,
});
